// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.939Z

import {
    GetContentByContentTypeAndContentNameApiResponse,
    GetContentByContentTypeAndContentNameApiArg
} from "~/api/contentAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getContentByContentTypeAndContentName: build.query<
            GetContentByContentTypeAndContentNameApiResponse,
            GetContentByContentTypeAndContentNameApiArg
        >({
            query: (queryArg) => ({url: `/content/${queryArg["content-type"]}/${queryArg["content-name"]}`}),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as contentAPI };
export const {
    useGetContentByContentTypeAndContentNameQuery,
    useLazyGetContentByContentTypeAndContentNameQuery,
} = injectedRtkApi;
